import { LOGIN, TEMPORARY_LOGIN, LOGIN_RESULT, POSITION_UPDATED,PASSWORD_UPDATED,  BEEN_MODERATED, LOGGED_OUT, LOG_OUT, UPDATE_OWN_AVATAR, USER_DELETED, START_PLAYING, STOP_PLAYING } from './actions'
import {SAVED_EXP_USER, SAVED_NEW_USERNAME} from '../users/index'
export const user = (state = { isLogged: false }, action) => {
    const { type, ...data } = action
    switch (type) {
        case LOGIN:
            return {
                ...state,
                ...data,
                isLogging: true,
                isLogged: false
            }

        case TEMPORARY_LOGIN:
            return {
                ...state,
                ...data,
                isLogging: true,
                isLogged: false
            }
        
        case LOGIN_RESULT:
            return {
                ...state,
                ...data,
                isLogged: !data.error,
                isLogging: false
            }

        case POSITION_UPDATED:
        return {
                ...state,
                position: action.position,
                balance: action.balance
            }

        case BEEN_MODERATED:
            const isBanned = 1 - (state.exp_user.is_banned);
            return {
                 ...state,
                 exp_user: {
                    ...state.exp_user,
                    is_banned:isBanned
                 }
             }
       
        case LOG_OUT:
             return {
                 ...state,
                 isLogged:false
             }

        case START_PLAYING:
        return {
            ...state,
            is_playing:1
        }

        case STOP_PLAYING:
        return {
            ...state,
            is_playing:0
        }

        case USER_DELETED: 
             return null;

        case  PASSWORD_UPDATED:
            return{
                ...state,
                password_updated:1
            }

        case LOGGED_OUT:
             return {
                 is_logged:false,
                 is_playing: 0
             }
             
        case SAVED_NEW_USERNAME:
            return {
                ...state,
                username: action.username
            }
       
        case SAVED_EXP_USER:
            return {
                ...state,
                exp_user: {
                    ...state.exp_user,
                    from: action.exp_user.from, 
                    claim: action.exp_user.claim,
                    real_name   : action.exp_user.real_name,
                    paypal_account: action.exp_user.paypal_account,
                    has_webcam: action.exp_user.has_webcam,
                    avatar: action.exp_user.avatar,
                }
            }

        case UPDATE_OWN_AVATAR:
            return {
                ...state,
                exp_user: {
                    ...state.exp_user,
                    avatar: action.avatar
                }
            }

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/user/index.js